export const isLocalStage = process.env.REACT_APP_STAGE === "local";
